import columns from '../../../../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    ExternalDespatchLinkColumn,
    DateTimeColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin IMPC operator', 'originImpcOperator'),
        new TextColumn('Origin IMPC', 'originImpc'),
        new TextColumn('Sending mailbox', 'sendingMailbox'),
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchId').withWidth(240)),
        new NonZeroNumberColumn('Occurrences', 'occurrences'),
        new NonZeroNumberColumn('PREDES messages per despatch - Median', 'predMedian'),
        new TextColumn('Receptacles added', 'receptaclesAdded'),
        new TextColumn('Receptacles removed', 'receptaclesRemoved'),
        new TextColumn('Items added', 'itemsAdded'),
        new TextColumn('Items removed', 'itemsRemoved'),
        new TextColumn('Weight changed', 'weightChanged'),
        new TextColumn('AMSC changed', 'amscChanged'),
        new TextColumn('Transport changed', 'transportChanged'),
        new DateTimeColumn('First close date', 'firstCloseDate'),
        new DateTimeColumn('Last close date', 'lastCloseDate'),
        new NonZeroNumberColumn('Last - first close date (days)', 'closeDateDayDiff'),
      ],
    },
  ];
};
